import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="border-t border-zinc-900 bg-[#09090b] mt-16">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
                <div>
                    <img
                        src="/brand/sponsormania-logo.png"
                        alt="Sponsormania.fr"
                        className="h-12 w-auto object-contain mb-3"
                    />
                    <p className="text-sm text-zinc-400 leading-relaxed">
                        La plateforme solidaire qui finance les maillots des clubs amateurs.
                        <span className="block mt-2 font-bold text-orange-500">0% de commission.</span>
                    </p>
                </div>
                <div>
                    <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-3 font-bold">
                        Plateforme
                    </h4>
                    <ul className="space-y-2 text-sm text-zinc-300">
                        <li>
                            <Link to="/clubs" className="hover:text-orange-500">
                                Trouver un club
                            </Link>
                        </li>
                        <li>
                            <Link to="/concept" className="hover:text-orange-500">
                                Le concept
                            </Link>
                        </li>
                        <li>
                            <Link to="/realisations" className="hover:text-orange-500">
                                Nos réalisations
                            </Link>
                        </li>
                        <li>
                            <Link to="/panther" data-testid="footer-panther" className="hover:text-orange-500">
                                Notre partenaire Panther
                            </Link>
                        </li>
                        <li>
                            <Link to="/register" className="hover:text-orange-500">
                                Devenir sponsor
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-3 font-bold">
                        Clubs
                    </h4>
                    <ul className="space-y-2 text-sm text-zinc-300">
                        <li>
                            <Link to="/register" className="hover:text-orange-500">
                                Inscrire mon club
                            </Link>
                        </li>
                        <li>
                            <Link to="/login" className="hover:text-orange-500">
                                Tableau de bord
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-3 font-bold">
                        Légal
                    </h4>
                    <ul className="space-y-2 text-sm text-zinc-300">
                        <li>
                            <Link to="/cgu" data-testid="footer-cgu" className="hover:text-orange-500">
                                CGU
                            </Link>
                        </li>
                        <li>
                            <Link to="/mentions-legales" data-testid="footer-mentions" className="hover:text-orange-500">
                                Mentions légales
                            </Link>
                        </li>
                        <li>
                            <Link to="/confidentialite" data-testid="footer-privacy" className="hover:text-orange-500">
                                Confidentialité
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-zinc-900 py-6 text-center text-xs text-zinc-500 uppercase tracking-widest">
                © {new Date().getFullYear()} Sponsormania.fr — Service gratuit, 0% commission.
            </div>
        </footer>
    );
}
